
if (!customElements.get("before-after-image-slider")) {
  customElements.define(
    "before-after-image-slider",
    class BeforeAfterImageSlider extends HTMLElement {
      connectedCallback() {
        this.mediaWrapper = this.querySelector("[data-media-wrapper]");
        this.inputSlider = this.querySelector("[data-input-slider]");

        if (!this.mediaWrapper || !this.inputSlider) return;

        // Start at the far right: The Resource
        this.inputSlider.value = "100";

        this._syncValue = this.syncValue.bind(this);

        this.inputSlider.addEventListener("input", this._syncValue);
        this.inputSlider.addEventListener("change", this._syncValue);

        this.syncValue();
      }

      disconnectedCallback() {
        if (!this.inputSlider) return;

        this.inputSlider.removeEventListener("input", this._syncValue);
        this.inputSlider.removeEventListener("change", this._syncValue);
      }

      syncValue() {
        const min = Number(this.inputSlider.min);
        const max = Number(this.inputSlider.max);
        const value = Number(this.inputSlider.value);

        const compareValue = Math.round(
          ((value - min) / (max - min)) * 100
        );

        this.mediaWrapper.style.setProperty(
          "--before-after-value",
          String(compareValue)
        );
      }
    }
  );
}
